import { kebabCase } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import ActionPopOutOption from "@/view/ActionPopOutOption";
import getShareUrl from "../utils/getShareUrl";

const propTypes = {
  contentType: PropTypes.string,
  currentLevelId: PropTypes.string,
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    baseShareUrl: PropTypes.string,
    href: PropTypes.string,
    params: PropTypes.shape({
      app_id: PropTypes.number,
      description: PropTypes.string,
      link: PropTypes.string,
      media: PropTypes.string,
      redirectUri: PropTypes.string,
      referrer: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
    }),
  }).isRequired,
};

const ShareOption = ({ contentType, currentLevelId, option, dataProps }) => {
  const { name, description, icon, onClick, baseShareUrl, href, params } =
    option;

  const eventProperties = {
    objectType: "Content",
    actionName: "Share",
    streamProperties: {
      content_type: contentType,
      description,
      content_id: currentLevelId,
      ...(name && {
        selected_option: kebabCase(name.toLowerCase()),
      }),
    },
  };

  return (
    <ActionPopOutOption
      currentLevelId={currentLevelId}
      title={name}
      description={description}
      icon={icon}
      onClick={onClick}
      href={href ?? getShareUrl(baseShareUrl, params)}
      eventProperties={eventProperties}
      dataProps={dataProps}
    />
  );
};

ShareOption.propTypes = propTypes;

export default ShareOption;
